import { Injectable } from '@angular/core';
import { lastValueFrom, Observable, of } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AdsPage } from '../../../projects/shared-lib/src/lib/models/ads-page';
import { CartService } from '../../../projects/shared-lib/src/lib/services/cart.service';
import { listAdsPages } from './mock-data';
import { Coordinate, getDistanceBetweenTwoPoints } from '../../../projects/shared-lib/src/lib/utils/utilsShared';
import { Cart } from '../../../projects/shared-lib/src/lib/models/cart';
import { SubdomainService } from '../../../projects/shared-lib/src/lib/services/subdomain.service';
import { HelpsService } from '../../../projects/shared-lib/src/lib/utils/helps.service';

@Injectable({
    providedIn: 'root',
})
export class AdsPagesService {
    dist = 100;
    constructor(
        private http: HttpClient,
        private cartService: CartService,
        private subdomainService: SubdomainService,
        public helpsService: HelpsService,
    ) {}

    async getAdsPage(): Promise<AdsPage[]> {
        try {
            // return listAdsPages;
            if (this.subdomainService.getSubdomain().search('tpro') === -1) {
                return null;
            }
            const detail = await this.helpsService.getGeoProvince();

            let h = new HttpParams();
            h = h.set('dist', this.dist);
            h = h.set('city', detail.city);
            h = h.set('province', detail.ab);
            h = h.set('latitude', detail.latitude);
            h = h.set('longitude', detail.longitude);
            const coordinateSale = {
                lat: 45.5052557,
                lon: -73.5640771,
            };
            const distKml = getDistanceBetweenTwoPoints(coordinateSale, {
                lat: detail.latitude,
                lon: detail.longitude,
            });
            console.log(distKml);
            if (distKml > this.dist) {
                return this.filterByCart();
            }
            return [];
        } catch (e) {
            return null;
        }

        //return this.http.get<AdsPage[]>('v1/pages-ads', {params: h});
    }
    filterByCart() {
        if (this.subdomainService.getSubdomain().search('tpro') === -1) {
            return null;
        }
        const cart: Cart = this.cartService.cartSub.value;
        if (!cart) {
            return null;
        }
        try {
            return listAdsPages
                .map((adsPage) => {
                    //console.log(cart.cartElements.find(cartElement =>  adsPage.showIds.find(showId => showId === cartElement.showId)!== undefined))
                    if (
                        adsPage.showIds &&
                        !cart.cartElements.find((cartElement) => adsPage.showIds.find((showId) => showId === cartElement.showId)) &&
                        cart.cartElements.find((cartElement) => {
                            if (
                                cartElement.location &&
                                cartElement.location.city &&
                                (cartElement.location.city.toLowerCase() === 'montréal' ||
                                    cartElement.location.city.toLowerCase() === 'montreal')
                            ) {
                                return cartElement;
                            }
                            return undefined;
                        })
                    ) {
                        return adsPage;
                    }
                })
                .filter((value) => value !== undefined);
        } catch (e) {
            console.log(e);
            return null;
        }
    }
}
